import React, {forwardRef, useImperativeHandle, useState} from 'react';
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { AllModules } from '@ag-grid-enterprise/all-modules';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine-dark.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-material.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css';
import _ from "underscore";
import __ from "lodash";

import {DatagridControls} from "./index";

//import MaskedNumber from "./MaskedNumber";

const KEY_UP = 38;
const KEY_DOWN = 40;

const Wrapper = props => {
  const component = props.component;
  if (props && props.component && props.component.props) {
    const componentProps = props.component.props;
    const wrappedFunctions = props && props.component && props.component.props.wrappedFunctions;
    if (typeof wrappedFunctions === 'object') {
      Object.entries(wrappedFunctions).forEach(([entry, func]) => {
        componentProps[entry] = (value) => func(value, __.omit(props, ['component']));
      });
    }
  }

  return (
    <div style={{position:"relative", display:"inline-block"}}>
      {component}
    </div>
  )
}

const DataGrid = forwardRef((props, ref) => {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const gridId = props.id||"myGrid";
  const columns = props.columns;
  const rows = props.rows;
  const topRow = props.toRow;
  const summaryRow = props.summaryRow;
  let controls = {Wrapper, ...DatagridControls}
  if (props.components) {
    controls = {Wrapper, ...DatagridControls, ...props.components};
  }

  function getPinnedTopData() {
    return [topRow];
  }

  function getPinnedBottomData() {
    return [summaryRow];
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if (props.onGridReady) {
      props.onGridReady(params);
    }
  };

  const onRowValueChanged = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if (props.onRowValueChanged) {
      props.onRowValueChanged(params);
    }
  }

  const onRowDataUpdated = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if (props.onRowDataUpdated) {
      props.onRowDataUpdated(params);
    }
  }

  const onCellValueChanged = (event) => {
    // callback for parent summary code
    if (event.colDef.valueChanged)
      event.colDef.valueChanged();

    // Update the column summary
    const columnName = event.colDef.field;
    let currentValue = summaryRow ? Number(summaryRow[columnName]) : 0;
    let newValue = currentValue - (isNaN(Number(event.oldValue)) ? 0 : Number(event.oldValue)) + Number(event.newValue);
    if (summaryRow && __.has(summaryRow, columnName))
      summaryRow[columnName] = newValue;

    // Update the row total
    const colNamePrefix = columnName.substr(0, columnName.indexOf("_"));
    const rowData = event.data;
    const currentTotalValue = Number(rowData[colNamePrefix]);
    const newTotalValue = currentTotalValue - Number(event.oldValue) + Number(event.newValue);
    rowData[colNamePrefix] = newTotalValue;

    // Update the Total column Summary
    currentValue = summaryRow ? Number(summaryRow[colNamePrefix]) : 0;
    newValue = currentValue - Number(event.oldValue) + Number(event.newValue);
    if (summaryRow) {
      summaryRow[colNamePrefix] = newValue;
      gridApi.setPinnedBottomRowData([summaryRow]);
    }

    gridApi.refreshCells();
  };

  useImperativeHandle(ref, () => ({

    getAllGridRows () {
      let rowData = [];
      gridApi.forEachNode(node => rowData.push(node.data));
      return rowData;
    }

  }));

  const onBtStopEditing = () => {
    gridApi.stopEditing();
  };

  const onBtStartEditing = (key, char, pinned) => {
    gridApi.setFocusedCell(0, 'lastName', pinned);
    gridApi.startEditingCell({
      rowIndex: 0,
      colKey: 'lastName',
      rowPinned: pinned,
      keyPress: key,
      charPress: char,
    });
  };

  const onBtNextCell = () => {
    gridApi.tabToNextCell();
  };

  const onBtPreviousCell = () => {
    gridApi.tabToPreviousCell();
  };

  const onBtWhich = () => {
    var cellDefs = gridApi.getEditingCells();
    if (cellDefs.length > 0) {
      var cellDef = cellDefs[0];
      console.log(
        'editing cell is: row = ' +
        cellDef.rowIndex +
        ', col = ' +
        cellDef.column.getId() +
        ', floating = ' +
        cellDef.rowPinned
      );
    } else {
      console.log('no cells are editing');
    }
  };

  const renderColumn = (column, child) => {
    const headerDef = {};
    if (child) {
      headerDef['cellStyle']=column.headerName === 'Actual' ? {'border-right-color': '#e2e2e2'}: undefined
    }
    if (column.headerName){
      headerDef['headerName']=column.headerName;
    }

    return (
      <AgGridColumn
        {...headerDef}
        {...column.options}
        key={column.field}
        field={column.field}
        width={column.width}
        minWidth={column.minWidth || column.width}
        maxWidth={column.maxWidth || column.width}
        flex={column.flex}
        editable={column.editable === undefined ? true : column.editable}
        hide={column.hide === undefined ? false : column.hide}
        type={column.type}
        pinned={column.pinned}
        autoHeight={column.autoHeight}
        wrapText={column.wrapText}
        suppressNavigable={column.navigable===undefined?false:!(column.navigable)}
        suppressMenu={column.suppressMenu===undefined?false:(column.suppressMenu)}
        cellEditor= {column.cellEditor && typeof column.cellEditor !== "function" ? column.cellEditor.component : undefined}
        cellEditorParams={column.cellEditor && typeof column.cellEditor !== "function" ? column.cellEditor.params : undefined}
        cellEditorSelector={typeof column.cellEditorSelector === "function"? column.cellEditorSelector : undefined}
        cellRenderer={column.cellRenderer ? column.cellRenderer.component ? column.cellRenderer.component : column.cellRenderer : undefined}
        cellRendererParams={column.cellRenderer && column.cellRenderer.component ? column.cellRenderer.params : undefined}
        cellRendererSelector={typeof column.cellRendererSelector === "function"? column.cellRendererSelector : undefined}
        valueFormatter={typeof column.valueFormatter === "function"? column.valueFormatter : undefined}
        valueGetter={typeof column.valueGetter === "function"? column.valueGetter : undefined}
        valueSetter={typeof column.valueSetter === "function"? column.valueSetter : undefined}
        tooltipField={column.tooltipField}
        tooltipComponent={typeof column.tooltipComponent === "function"? column.tooltipComponent : undefined}
        tooltipValueGetter={typeof column.tooltipValueGetter === "function"? column.tooltipValueGetter : undefined}
        tooltipComponentParams={ column.tooltipComponentParams && typeof column.tooltipComponentParams === "object" ? {...column.tooltipComponentParams} : undefined}
        //valueChanged={typeof column.valueChanged === "function"? column.valueChanged : undefined}
        onCellValueChanged={typeof column.onCellValueChanged === "function"? column.onCellValueChanged : undefined}
        suppressKeyboardEvent={params => {
          //console.log('cell is editing: ' + params.editing);
          //console.log('keyboard event:', params.event);
          if (column.editable !== undefined && !column.editable)
            return false;

          // return true (to suppress) if editing and user hit up/down keys
          const keyCode = params.event.keyCode;
          const gridShouldDoNothing = params.editing && (keyCode===KEY_UP || keyCode===KEY_DOWN);
          return gridShouldDoNothing;
        }}
      />
    );
  }

  const renderChildColumns = (headerName) => {
    const children = _.where(columns, {parent: headerName});
    return(
      children.map((column) => renderColumn(column, true))
    );
  }

  const renderColumns = () => {
    return (
      columns.map((column) => {
        if ("headerName" in column && !("field" in column)){
          return(<AgGridColumn headerName={column.headerName} marryChildren={true} cellStyle={{'border-right-color': '#e2e2e2'}}>
            {renderChildColumns(column.headerName)}
          </AgGridColumn>);
        } else if (! ("parent" in column))
          return renderColumn(column)
       })
    );
  }

  return (
    <div style={props.style}>
      <div style={{display: "flex", flexDirection: "column"}}>
        <div
          style={{
            marginBottom: '5px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
        </div>
        <div style={{flex: "1 1 0px"}} >
          <div
            id={gridId}
            style={{
              height: props.height||500,
              width: props.width||"100%",
            }}
            className="ag-theme-alpine"
          >
            <AgGridReact
              modules={AllModules}
              rowData={rows}
              defaultColDef={{
                flex: 1,
                minWidth: 110,
                editable: true,
                resizable: false,
              }}
              frameworkComponents={controls}
              pinnedTopRowData={topRow ? getPinnedTopData() : undefined}
              pinnedBottomRowData={summaryRow ? getPinnedBottomData() : undefined}
              onGridReady={onGridReady}
              onCellValueChanged={onCellValueChanged}
              onRowDataUpdated={onRowDataUpdated}
              {...props.options}
            >
              {renderColumns()}
            </AgGridReact>
          </div>
        </div>
      </div>
    </div>
  );
});

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === 'undefined' ? event.keyCode : event.which;
}
function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}
function isKeyPressedNumeric(event) {
  var charCode = getCharCodeFromEvent(event);
  var charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}

export {
  DataGrid as default,
  Wrapper
};
